const ContactSection = () => {
  return (
    <section className="px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-15">
      <div className="">
        <div
          className="
            bg-gradient-to-br from-black via-slate-900 to-blue-950
            rounded-md
            p-6 sm:p-10 lg:p-14
            text-center
            relative
            overflow-hidden
          "
        >
          <p
            className="
              text-blue-500
              uppercase
              tracking-[0.3em] sm:tracking-[0.4em]
              text-[10px] sm:text-xs
              font-black
              mb-4
            "
          >
            Contact Us
          </p>

          <h2
            className="
              text-2xl
              sm:text-4xl
              lg:text-5xl
              font-black
              uppercase
              text-white
              leading-tight
            "
          >
            Protect Your Space
            <span className="text-blue-500 block sm:inline">
              {" "}
              With Confidence
            </span>
          </h2>

          <p
            className="
              mt-5 sm:mt-6
              max-w-xl
              mx-auto
              text-slate-400
              text-xs sm:text-sm
              leading-relaxed
              lg:whitespace-nowrap
            "
          >
            Need CCTV installation or complete security solutions? Our experts
            are ready to help you build a safer environment.
          </p>

          <button
            onClick={() => (window.location.href = "/contact")}
            className="
              mt-7 sm:mt-8
              w-full sm:w-auto
              bg-blue-600
              hover:bg-blue-500
              text-white
              px-8 sm:px-10
              py-3 sm:py-4
              rounded
              font-black
              uppercase
              text-[10px] sm:text-xs
              tracking-widest
              transition-all
            "
          >
            Get In Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
